import { useState, useEffect } from 'react';
import { getApiBase } from '../api.js';

const STORAGE_KEY = 'ovr_capabilities_v1';

export default function useCapabilities() {
  const [capabilities, setCapabilities] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    // Try localStorage fallback first for instant render
    try {
      const cached = localStorage.getItem(STORAGE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed && parsed.context) {
          setCapabilities(parsed);
          setLoading(false);
        }
      }
    } catch {
      // ignore parse errors
    }

    fetch(`${getApiBase()}/api/capabilities`, { cache: 'no-store' })
      .then((resp) => {
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
        return resp.json();
      })
      .then((data) => {
        if (cancelled) return;
        // Portal redirect: if unauthenticated on portal, go to login
        if (data.portal && data.role === 'anonymous' && data.login_url) {
          window.location.href = data.login_url;
          return;
        }
        setCapabilities(data);
        setError(null);
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch {
          // storage full — ignore
        }
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  const isEdge = capabilities?.context === 'edge';
  const isCloud = capabilities?.context === 'cloud';

  return { capabilities, loading, error, isEdge, isCloud };
}
